const SvgComponent = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.75 1.25H6.25C5.75272 1.25 5.27581 1.44754 4.92417 1.79917C4.57254 2.15081 4.375 2.62772 4.375 3.125V16.875C4.375 17.3723 4.57254 17.8492 4.92417 18.2008C5.27581 18.5525 5.75272 18.75 6.25 18.75H13.75C14.2473 18.75 14.7242 18.5525 15.0758 18.2008C15.4275 17.8492 15.625 17.3723 15.625 16.875V3.125C15.625 2.62772 15.4275 2.15081 15.0758 1.79917C14.7242 1.44754 14.2473 1.25 13.75 1.25ZM14.375 16.875C14.375 17.0408 14.3092 17.1997 14.1919 17.3169C14.0747 17.4342 13.9158 17.5 13.75 17.5H6.25C6.08424 17.5 5.92527 17.4342 5.80806 17.3169C5.69085 17.1997 5.625 17.0408 5.625 16.875V3.125C5.625 2.95924 5.69085 2.80027 5.80806 2.68306C5.92527 2.56585 6.08424 2.5 6.25 2.5H13.75C13.9158 2.5 14.0747 2.56585 14.1919 2.68306C14.3092 2.80027 14.375 2.95924 14.375 3.125V16.875ZM10.9375 4.6875C10.9375 4.87292 10.8825 5.05418 10.7795 5.20835C10.6765 5.36252 10.5301 5.48268 10.3588 5.55364C10.1875 5.62459 9.99896 5.64316 9.8171 5.60699C9.63525 5.57081 9.4682 5.48152 9.33709 5.35041C9.20598 5.2193 9.11669 5.05225 9.08051 4.8704C9.04434 4.68854 9.06291 4.50004 9.13386 4.32873C9.20482 4.15743 9.32498 4.01101 9.47915 3.908C9.63332 3.80498 9.81458 3.75 10 3.75C10.2486 3.75 10.4871 3.84877 10.6629 4.02459C10.8387 4.2004 10.9375 4.43886 10.9375 4.6875Z"
        fill="black"
      />
    </svg>
  )
}

export default SvgComponent
